import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c878df9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "android-seat-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: $setup.drawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.drawer) = $event)),
      size: "auto",
      "with-header": false,
      "before-close": $setup.close_sidebar
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" 安卓端顶部占位 "),
        ($setup.config.android)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_el_menu, {
          class: "right-sidebar-menu",
          "active-text-color": "#ffd04b",
          "background-color": "#545c64",
          "text-color": "#fff",
          onSelect: $setup.menu_select
        }, {
          default: _withCtx(() => [
            ($setup.idDouble)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: "remove-first"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.removeFirstTitle), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_el_menu_item, { index: "bookmark" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.bookmarkTitle), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            ($setup.idDouble)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 1,
                  index: "direction"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('option.direction')) + " (" + _toDisplayString($setup.directionTitle) + ")", 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_el_menu_item, { index: "dwonload" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('option.dwonload')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "operation" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.operationText), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}